import React, {PureComponent} from 'react'
import {connect} from 'react-redux'
import cn from "classnames"
import PropTypes from 'prop-types'
import injectStyles from "react-jss"
import {openShopTheLookDialog} from '../../actions'
import ShopIcon from "../Widgets/ShopIcon"
import {getFlickityDragEndTime} from '../../selectors'

class ShopTheLookLink extends PureComponent {

    _openShopTheLookDialog = () => {
        const {handleOpenShopTheLookDialog, title, shopItems, image, flickityDragEndTime } = this.props;

        var date = new Date();
        // Check if we just dragged a courousel, if we did do not open the dialog
        // TODO A better solution would be to use staticClick on flickity
        if(flickityDragEndTime && date.getTime() - flickityDragEndTime <= 100)
                return;

        //const box = this._ref.getBoundingClientRect();
        handleOpenShopTheLookDialog('dialog', title, { image, shopItems } );
    }

    _setRef = (ref) => {
        const {setRef} = this.props;
        this._ref = ref;
        if(setRef) setRef(ref);
    }

    render() {
        const {classes, className, verticalPosition='Bottom', horizontalPosition='Right'} = this.props;

        const positionClass = cn({
            [classes.bottom]: !verticalPosition || verticalPosition === 'Bottom',
            [classes.top]: verticalPosition === 'Top',
            [classes.left]: !horizontalPosition || horizontalPosition === 'Left',
            [classes.right]: horizontalPosition === 'Right',
            [classes.centerCenter]: horizontalPosition === 'Center' && verticalPosition === 'Center',
            [classes.centerHorizontal]: horizontalPosition === 'Center' && verticalPosition !== 'Center',
            [classes.centerVertical]: verticalPosition === 'Center' && horizontalPosition !== 'Center',

        })

        return <a className={cn(classes.link, className)} onClick={this._openShopTheLookDialog} ref={this._setRef}>
            <div className={cn('shopTheLook', positionClass)}>
                <ShopIcon />
                <span>Shop the look</span>
            </div>
        </a>
    }
}

ShopTheLookLink.propTypes = {
    title: PropTypes.string,
    shopItems: PropTypes.array.isRequired,
    image: PropTypes.object.isRequired,
    horizontalPosition: PropTypes.string,
    verticalPosition: PropTypes.string,
    setRef: PropTypes.func
}

const mapStateToProps = (state) => {
    return {
        flickityDragEndTime: getFlickityDragEndTime(state)
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleOpenShopTheLookDialog: (id, title, shopItems ) => {
            dispatch( openShopTheLookDialog(id, title, shopItems ) );
        }
    }
}

export default injectStyles((theme) => ({
    link: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        '& .shopTheLook': {
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: theme.colors.white,
            padding: '0 10px',
            bottom: 8,
            right: 8,
            transition: 'width 0.3s ease',
            width: 32,
            borderRadius: 32,
            lineHeight: '32px',
            boxShadow: '0 1px 4px 0 rgba(0,0,0,0.16)',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textTransform: 'none',
            "& svg": {
                flexShrink: 0,
                width: 14,
                height: 14,
                color: '#464646'
            },
            "& span": {
                opacity: 0,
                transition: 'opacity 0.3s ease',
                marginLeft: '5px',
                color: theme.colors.primary,
                fontSize: '12px',
                letterSpacing: '0.3px'
            }
        },
        "&:hover .shopTheLook": {
            width: '113px',
            "& span": {
                opacity: 1
            },
            "& svg": {
                color: theme.colors.primary
            }
        },
        "&:active .shopTheLook": {
            boxShadow: '0 1px 4px 0 rgba(0,0,0,0.32)',
            "& span, & svg": {
                color: `${theme.colors.black} !important`
            }
        }
    },
    top: {
        top: theme.spacing.small,
    },
    bottom: {
        bottom: theme.spacing.small,
    },
    right: {
        right: theme.spacing.small,
    },
    centerHorizontal: {
        left: '50%',
        transform: 'translate(-50%, 0)'
    },
    centerVertical: {
        top: '50%',
        transform: 'translate(0, -50%)'
    },
    centerCenter: {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }
}))(connect(mapStateToProps, mapDispatchToProps)(ShopTheLookLink))





// WEBPACK FOOTER //
// ./src/components/ShopThLook/ShopTheLookLink.js